module.exports = __webpack_public_path__ + "static/media/3.77f9e458.jpg";